import { Tab } from '@legacy-vfuk/core-tabs';
import SWSectionServicesBanner from '@/components/pageBuilder/Sections/SWSectionServicesBanner';
import SWSectionTariffCards from '@/components/pageBuilder/Sections/SWSectionTariffCards';

import {
  CONTENTFUL_SECTION_SW_SERVICES_BANNER,
  CONTENTFUL_SECTION_SW_TARIFF_CARDS,
} from '@/templates/page-builder-helpers';

import { SWSectionTabProps, SWSectionTabsProps, TabSectionProps } from './SWSectionTabs.types';
import { TabsContainer, TabsWrapper } from './SWSectionTabs.styles';
import { useEffect, useState } from 'react';
import { Element, scroller } from 'react-scroll';

const SW_SECTION_TABS_SCROLL_NAME = 'sw-section-tabs';

const SWSectionTabs = ({ tabs, startTabIndex }: SWSectionTabsProps) => {
  const getTabId = (tab: SWSectionTabProps) => {
    return `appearance-${tab.name}-tab-${tab.label}`;
  };
  const getTabSections = (section: TabSectionProps) => {
    switch (section.__typename) {
      case CONTENTFUL_SECTION_SW_SERVICES_BANNER:
        return <SWSectionServicesBanner key={section.id} {...section} />;
      case CONTENTFUL_SECTION_SW_TARIFF_CARDS:
        return <SWSectionTariffCards key={section.id} {...section} />;
      default:
        return <></>;
    }
  };

  const [activeTabId, setActiveTabId] = useState(getTabId(tabs[startTabIndex || 0]));

  const handleScrollToTabs = () => {
    scroller.scrollTo(SW_SECTION_TABS_SCROLL_NAME, {
      smooth: true,
      spy: false,
      offset: -113,
    });
  };

  useEffect(() => {
    const listener = (event: Event) => {
      const customEvent = event as CustomEvent<{ typename: string }>;
      const typename = customEvent.detail?.typename;
      if (!typename) return;

      // Match tab by nested section __typename (tabs themselves have no __typename)
      const matchedTab = tabs.find(tab => tab.value?.some(section => section.__typename === typename));
      if (matchedTab) {
        setActiveTabId(getTabId(matchedTab));
        handleScrollToTabs();
      }
    };

    window.addEventListener('switch-tab', listener);
    return () => {
      window.removeEventListener('switch-tab', listener);
    };
  }, [tabs]);

  return (
    <Element name={SW_SECTION_TABS_SCROLL_NAME}>
      <TabsContainer>
        <TabsWrapper
          appearance={'primary'}
          key="primary"
          externallySetTabId={activeTabId}
          onTabClick={tabId => setActiveTabId(tabId)}
        >
          {tabs.map(tab => {
            const { value, label, name } = tab;
            const tabId = getTabId(tab);
            return (
              <Tab key={`${name}-tab-${label}`} text={label} id={tabId} data-selector="SWSectionTabs">
                {value?.map(item => (
                  <div key={item.id} id={`section-${item.__typename}`}>
                    {getTabSections(item)}
                  </div>
                ))}
              </Tab>
            );
          })}
        </TabsWrapper>
      </TabsContainer>
    </Element>
  );
};

export default SWSectionTabs;
